/* Public STOQ Create Intent API. No private API key belongs in this file. */
if (!customElements.get('villago-restock-signup')) {
  customElements.define('villago-restock-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.bound = true;
      this.email = this.form.querySelector('input[type="email"]');
      this.button = this.form.querySelector('button[type="submit"]');
      this.feedback = this.form.querySelector('.vg-restock__feedback');
      this.label = this.button.textContent;
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.send();
      });
      this.button.disabled = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
    }

    showFeedback(message, state) {
      this.feedback.textContent = message;
      this.feedback.hidden = false;
      this.feedback.className = `vg-restock__feedback vg-restock__${state}`;
      this.feedback.setAttribute('role', state === 'error' ? 'alert' : 'status');
      const modal = this.closest('quick-add-modal');
      if (modal && typeof trapFocus === 'function') trapFocus(modal, this.feedback);
      else this.feedback.focus({ preventScroll: true });
    }

    async send() {
      if (this.pending || this.completed || !this.form.reportValidity()) return;
      const product = Number(this.dataset.product);
      const variant = Number(this.dataset.variant);
      if (!Number.isSafeInteger(product) || product <= 0 || !Number.isSafeInteger(variant) || variant <= 0
        || !/^[a-z0-9-]+\.myshopify\.com$/.test(this.dataset.shop || '')) {
        this.showFeedback('Não foi possível identificar o produto. Atualize a página e tente novamente.', 'error');
        return;
      }
      const email = this.email.value.trim();
      this.pending = true;
      this.button.disabled = true;
      this.button.textContent = 'Cadastrando…';
      this.email.readOnly = true;
      this.form.setAttribute('aria-busy', 'true');
      this.feedback.hidden = true;
      this.controller = new AbortController();
      this.timer = setTimeout(() => this.controller.abort(), 25000);
      try {
        const response = await fetch('https://app.stoqapp.com/api/v1/intents.json', {
          method: 'POST', credentials: 'omit', signal: this.controller.signal,
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Shop-Domain': this.dataset.shop },
          body: JSON.stringify({
            intent: { shopify_product_id: product, shopify_variant_id: variant, channel: 'email', quantity: 1, source: 'api' },
            customer: { email, accepts_marketing: false, locale: this.dataset.locale || 'pt-BR', country: (this.dataset.country || 'BR').toLowerCase() },
          }),
        });
        const result = await response.json();
        if (!this.isConnected) return;
        // STOQ can return HTTP 200 with errors. Only a matching intent is confirmation.
        const intent = Array.isArray(result.intents) && result.intents.find(item =>
          item.id && item.channel === 'email' && Number(item.shopify_product_id) === product
          && Number(item.shopify_variant_id) === variant
          && String(item.email || item.customer?.email).toLowerCase() === email.toLowerCase());
        // The live widget returns a nested customer and an errors object;
        // the API reference also documents a flat email and an errors array.
        const errors = result.errors;
        const hasErrors = errors != null && (typeof errors !== 'object' || Object.keys(errors).length > 0);
        const duplicate = !Array.isArray(errors) && (errors?.already_registered === true || !!errors?.email_errors?.intent);
        if (!response.ok || (!intent && !duplicate) || (hasErrors && !duplicate)) {
          throw new Error('Signup not confirmed');
        }
        this.completed = true;
        this.form.querySelector('label').hidden = true;
        this.email.hidden = true;
        this.button.hidden = true;
        this.showFeedback(duplicate ? 'Este e-mail já está na lista de aviso deste produto. Avisaremos quando esta opção voltar ao estoque.' : intent.optin_confirmed === false
          ? 'Quase pronto! Confira seu e-mail e confirme o cadastro para receber o aviso.'
          : 'Pronto! Seu aviso foi cadastrado. Enviaremos um e-mail quando esta opção voltar ao estoque.', 'success');
        if (this.closest('quick-add-modal')) {
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'button button--full-width';
          close.setAttribute('data-modal-close', '');
          close.textContent = 'Continuar comprando';
          this.feedback.after(close);
        }
      } catch (_) {
        if (this.isConnected) this.showFeedback('Não foi possível confirmar o cadastro. Verifique seu e-mail e sua conexão e tente novamente em instantes.', 'error');
      } finally {
        clearTimeout(this.timer);
        this.pending = false;
        this.form.removeAttribute('aria-busy');
        this.button.disabled = this.completed === true;
        this.button.textContent = this.label;
        this.email.readOnly = false;
      }
    }
  });
}
